import styled from 'styled-components';
import { Card } from 'view/components/common';

export const Container = styled.div<{ isLoading: boolean; }>`
    position: relative;
    opacity: ${props => props.isLoading ? 0 : 1};
    transition: all 300ms ease 0.5s, visibility 0s linear 0s;
`;

export const UnderwritingCard = styled(Card)<{ docUploadStep: boolean }>`
    ${({ docUploadStep }) => docUploadStep && `
        width: 70%;
        text-align: center;

        @media only screen and (max-width: 600px) {
            width: 95%;
        }
    `}
`;
